import { useMemo } from 'react'
import { blue } from '@mui/material/colors'
import { useModelStore } from '@editorStores'
import useSceneLineMarker from '../useSceneLineMarker'
import { focusOutlines } from './utils'

const FOCUS_COLOR = blue[600]

/**
 * Draws outlines (blue unless `color` says otherwise) around the planar
 * elements with these guids -- their shape and their openings -- on top of
 * everything else in the scene (no depth test), so they show even behind
 * other elements. Nothing about the elements themselves changes. An empty
 * list draws nothing; several calls draw independent layers, the one with
 * the higher `renderOrder` on top where they overlap.
 */
const useFocusElements = (
  guids: string[],
  { color = FOCUS_COLOR, renderOrder = 1000 }: { color?: string; renderOrder?: number } = {},
): void => {
  const model = useModelStore(state => state.model)
  const lines = useMemo(() => focusOutlines(model, guids), [model, guids])

  useSceneLineMarker({
    lines,
    enabled: lines.length > 0,
    color,
    lineWidth: 3,
    renderOrder,
    disableDepthTest: true,
  })
}

export default useFocusElements
